let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g4qG6")).then(() => parcelRequire('iF4op'));